import "./AddPost.scss";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Loader from "../../loader/Loader";
import PostForm from "../postForm/PostForm";
import { useEffect, useState } from "react";
import {
  getTypes,
  getCategories,
} from "../../../redux/features/categoryAndType/categoryAndTypeSlice";
import { RESET_PROD, createPost } from "../../../redux/features/post/postSlice";
import { toast } from "react-toastify";

const initialState = {
  title: "",
  link: "",
  category: "",
  type: "",
};

const AddPost = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [post, setPost] = useState(initialState);
  const [content, setContent] = useState("");
  const [files, setFiles] = useState([]);

  const { isLoading, message } = useSelector((state) => state.post);

  const { title, link, category, type } = post;

  const generateSKU = (category) => {
    const letter = category.slice(0, 3).toUpperCase();
    const number = Date.now();
    const sku = letter + "-" + number;
    return sku;
  };
  const savePost = async (e) => {
    e.preventDefault();

    if (files.length < 1) {
      return toast.error("Please add an image");
    }

    const formData = {
      title,
      link,
      sku: generateSKU(category),
      category,
      type,
      content,
      image: files,
    };
    // console.log(formData);
    await dispatch(createPost(formData));

    // navigate("/admin/all-posts");
  };

  useEffect(() => {
    if (message === "Post created Successful") {
      navigate("/admin/all-posts");
    }
    dispatch(RESET_PROD());
  }, [message, navigate, dispatch]);

  return (
    <section>
      <div className="container">
        {isLoading && <Loader />}
        <h2 className="mt">Add New Post</h2>

        <PostForm
          files={files}
          setFiles={setFiles}
          savePost={savePost}
          post={post}
          setPost={setPost}
          isEditing={false}
          content={content}
          setContent={setContent}
        />
      </div>
    </section>
  );
};
export default AddPost;
